import { useEffect } from "react";
import type { ModalContentProps } from "./Modal.types";
import { getModalStyles } from "./Modal.styles";
import { Button } from "@/components/atoms";

// O componente agora consome as ModalContentProps
export const Modal = ({
  isVisible,
  onClose,
  title,
  children,
  size = "md",
  hideCloseButton = false,
}: ModalContentProps) => {
  const styles = getModalStyles({ size, isVisible });

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  return (
    <>
      <div
        className={styles.overlay}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={styles.wrapper}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className={styles.dialog}>
          <div className={styles.header}>
            <h2
              id="modal-title"
              className={styles.title}
            >
              {title}
            </h2>
            {!hideCloseButton && (
              <Button
                variant="ghost"
                icon="times-hexagon"
                iconOnly
                size="sm"
                onClick={onClose}
                aria-label="Fechar modal"
              />
            )}
          </div>

          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </>
  );
};
